<template>
<div>
    <Breadcrumbs main="Admin" title="Spot On's" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(created)="row">
                                        {{row.value.split('T')[0]}}
                                    </template>

                                    <template #cell(title)="row">
                                        <div style="min-width: 220px; max-width: 280px;">{{ row.value }}</div>
                                    </template>

                                    <template #cell(video_link)="row">
                                        <div style="max-width: 280px;">
                                            <a :href="row.item.bunny_video_link" target="_blank" rel="noopener noreferrer">{{ row.item.bunny_video_link }}</a>
                                            <!-- If video exists -->
                                            <!-- <video v-if="row.item.bunny_video_link && row.item.bunny_video_link.endsWith('.mp4')" ref="videoElement" autoplay loop muted playsinline style="cursor: pointer; object-fit: cover; border-radius: 6px; background-color: oklch(87.2% 0.01 258.338); width: 100%; height: 340px;" @click="openFullscreen">
                                                <source :src="row.item.bunny_video_link" type="video/mp4" />
                                            </video> -->

                                            <!-- If no video → fallback background -->
                                            <!-- <div v-else style="background-color: oklch(87.2% 0.01 258.338); border-radius: 6px; width: 100%; height: 160px; padding: 40px; display: flex; align-items: end;">
                                                <div style="width: 100%; padding: 8px;">
                                                    <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: end; gap: 16px;">
                                                        <div>
                                                            <div style="width: 100%; display: flex; gap: 8px; align-items: center; justify-content: center;"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                                    </template>

                                    <template #cell(changemaker)="row">
                                        <div style="max-width: 250px; min-width: 160px;">
                                            <h7>{{ row.item.changemaker?.name }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(initiative)="row">
                                        <div style="max-width: 350px; min-width: 200px;">
                                            <h7>{{ row.item.initiative?.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(image)="row">
                                        <img style="max-height: 80px;" :src="host + row.item.image" alt="">
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteSpotOn(data.item.id)" title="Delete"></feather>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Spot On?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from '../../_helpers/host'

export default {

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'video_link',
                    label: 'Video',
                    sortable: true
                },
                {
                    key: 'changemaker',
                    label: 'Changemaker',
                    sortable: true
                },
                {
                    key: 'initiative',
                    label: 'Initiative',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: true
                }
            ],
            spoton_view: null,
            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            items: state => state.spoton.spotons,
            loading: state => state.spoton.spotonLoading,
            error: state => state.spoton.spotonError
        }),

        sortOptions() {
            return this.tablefields.filter(f => f.sortable).map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch('spoton/fetchSpotOnList').then(() => {
            this.totalRows = this.items.length;
        });
    },

    methods: {
        // truncateText(text, maxLength) {
        //     if (text.length > maxLength) {
        //         return text.substring(0, maxLength) + '...';
        //     } else {
        //         return text;
        //     }
        // },

        resetModal() {
            this.selectedStatus = '';
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        updateToggle(id) {
            this.$store.dispatch('spoton/updateStatusToggle', {
                spoton_id: id,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        },

        viewSpotOn(spoton) {
            this.spoton_view = spoton
        },

        deleteSpotOn(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch('spoton/deleteSpotOn', {
                delete_value: this.delete_value,
            }).then(response => {
                if (response.code == 204) {
                    Swal.fire({
                        title: 'Success!',
                        text: response.response,
                        icon: 'success'
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: response.response,
                        icon: 'error'
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
